@mixin default-btn {
  // --btn-padding-x: 0.75rem;
  // --btn-padding-y: 0.375rem;
  // --btn-font-family: ;
  // --btn-font-size: 1rem;
  // --btn-font-weight: 400;
  // --btn-line-height: 1.5;
  // --btn-color: var(--body-color);
  // --btn-bg: transparent;
  // --btn-border-width: var(--border-width);
  // --btn-border-color: transparent;
  // --btn-border-radius: var(--border-radius);
  // --btn-hover-border-color: transparent;

  --btn-box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 0, 0, 0.25);
  --btn-disabled-opacity: 0.55;
  //
  //
  //
  display: inline-block;
  // padding: var(--btn-padding-y) var(--btn-padding-x);
  // font-family: var(--btn-font-family);
  // font-size: var(--btn-font-size);
  // font-weight: var(--btn-font-weight);
  // line-height: var(--btn-line-height);
  // color: var(--btn-color);
  border: 2px solid var(--tg-theme-button-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  transition:
    scale 0.25s ease-in-out,
    opacity 0.25s ease-in-out,
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  //
  //
  //

  padding: 0.25rem 0.55rem;
  color: var(--tg-theme-button-text-color);
  border-radius: 0.625rem;

  //
  //
  //

  &:hover {
    // color: var(--btn-color);
    // background-color: var(--btn-bg);
    // border-color: var(--btn-hover-border-color);
  }

  &:focus {
    outline: 0;
    box-shadow: var(--btn-focus-box-shadow);
  }

  &:active {
    color: var(--tg-theme-text-color);
    background-color: transparent;
    box-shadow: var(--btn-box-shadow);
    // transform: scale(1.1);
    transform: translateY(2px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: var(--btn-disabled-opacity);
  }
}

//
//
//
//
//

.btn {
  @include default-btn;

  //
  //

  &_default,
  &_primary {
    color: var(--tg-theme-button-text-color);
    border-color: var(--tg-theme-button-color);
    background-color: var(--tg-theme-button-color);
    font-size: 1.05rem;
    font-weight: 300;

    &:hover {
      // color: var(--text-white);
      // border-color: var(--main-color-hover);
      // background-color: var(--main-color-hover);
      opacity: 0.8;
    }

    &:active {
      // color: var(--main-color-alt);
      // border-color: var(--main-color-alt);
    }
  }

  // &_primary-transparent {
  //   border-color: var(--main-color);
  //   background-color: var(--transparent);
  //   color: var(--main-color);
  //   font-size: 1.05rem;
  //   font-weight: 300;

  //   &:hover {
  //     background-color: var(--main-color);
  //     color: var(--text-white);
  //   }

  //   &:active {
  //     color: var(--main-color-alt);
  //     border-color: var(--main-color-alt);
  //   }
  // }

  &_secondary {
    color: var(--tg-theme-text-color);
    border: 2px solid var(--tg-theme-secondary-bg-color);
    background-color: var(--tg-theme-secondary-bg-color);
    font-size: 1.05rem;
    font-weight: 300;

    &:hover {
      opacity: 0.8;
    }

    &:focus {
      outline: none;
      box-shadow: none;
      font-weight: 300;
    }

    &:active {
      outline: none;
      box-shadow: none;
      font-weight: 300;
      color: var(--tg-theme-text-color) !important;
      border-color: var(--tg-theme-secondary-bg-color);
    }
  }

  //
  //
  //

  // &_link {
  //   border: 0;
  //   color: black;
  //   background-color: transparent;

  //   &:hover {
  //     opacity: 0.5;
  //   }

  //   &:active {
  //     color: var(--headings-color) !important;
  //     background-color: transparent !important;
  //     border-color: transparent !important;
  //     box-shadow: none !important;
  //   }

  //   &:focus {
  //     box-shadow: none !important;
  //   }

  //   //
  //   //

  //   &_active {
  //     text-decoration: underline;
  //   }
  // }

  &_wrapper {
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;

    &:hover {
      opacity: 0.75;
    }

    &:active {
      color: inherit !important;
      background-color: transparent !important;
      border-color: transparent !important;
      box-shadow: none !important;
      transform: translateY(1px);
    }

    &:focus {
      box-shadow: none !important;
    }
  }

  &_link {
    color: var(--tg-theme-text-color);
  }

  &_text-link {
    padding: 0;
    border: 0;
    color: inherit;
    vertical-align: baseline;
    background-color: transparent;

    &:hover {
      opacity: 0.65;
    }

    &:active,
    &:focus {
      color: inherit !important;
      transform: none;
      box-shadow: none !important;
    }

    &:active {
      transform: translateY(1px);
    }
  }

  // &_text-link-underline {
  //   padding: 0;
  //   border: 0;
  //   color: inherit;
  //   vertical-align: baseline;
  //   background-color: transparent;
  //   border-radius: 0;
  //   border-bottom: 1px solid currentColor;

  //   &:hover {
  //     opacity: 0.65;
  //   }

  //   &:active,
  //   &:focus {
  //     color: inherit !important;
  //     transform: none;
  //     box-shadow: none !important;
  //   }

  //   &:active {
  //     transform: translateY(1px);
  //   }
  // }

  // &_text-link-color {
  //   width: auto;
  //   padding: 0;
  //   border: 0;
  //   color: inherit;
  //   vertical-align: baseline;
  //   background-color: transparent;

  //   &:hover {
  //     opacity: 0.65;
  //     color: var(--secondary-color);
  //   }

  //   &:active,
  //   &:focus {
  //     color: inherit !important;
  //     transform: none;
  //     box-shadow: none !important;
  //   }

  //   &:active {
  //     transform: translateY(1px);
  //   }
  // }

  //
  //
  //

  // &_default {
  //   border-color: lighten(#6f80bd, 5%);
  //   background-color: #6f80bd;

  //   &:hover {
  //     background-color: darken(#6f80bd, 7.5%);
  //   }
  // }

  // &_success {
  //   border-color: lighten(#3aa72b, 5%);
  //   background-color: #3aa72b;

  //   &:hover {
  //     background-color: darken(#3aa72b, 7.5%);
  //   }
  // }

  // &_cancel {
  //   border-color: lighten(#ff6b6b, 5%);
  //   background-color: #ff6b6b;

  //   &:hover {
  //     background-color: darken(#ff6b6b, 7.5%);
  //   }
  // }

  // &_warning {
  //   border-color: lighten(#ff922b, 5%);
  //   background-color: #ff922b;

  //   &:hover {
  //     background-color: darken(#ff922b, 7.5%);
  //   }
  // }

  // &_important {
  //   color: black;
  //   border-color: darken(#ebd850, 25%);
  //   background-color: #ebd850;

  //   &:hover {
  //     background-color: darken(#ebd850, 10%);
  //   }
  // }

  //
  //
  //
  //
  //

  &_no-padding {
    padding: 0;
  }

  &_medium {
    padding: 0.6rem 1.55rem;
    min-height: 2.75rem;
  }

  &_width_auto {
    width: auto;
  }

  &_width_10 {
    width: 10rem;
  }

  &_big-content {
    font-size: 1.15rem;
    padding: 0.35rem 0.75rem;
  }

  &_small-content {
    font-size: 0.875rem;
    padding: 0.25rem 0.5rem;
  }

  &_smaller-content {
    padding: 0.1rem 0.3rem;
    font-size: 0.875rem;
    border-radius: 0.35rem;
  }

  &_thin-border {
    border-width: 1px;
  }
}
